import React from 'react'
import { connect } from 'react-redux'
import { getSafe } from '@/helpers/global';
import { getPortfolioAction } from '@/actions/trading'
import { Icons } from '@/configurations';
import TabHeader from '@/components/TabHeader/TabHeader';
import { CUSTOM_STYLES } from '@/constants/app';
import PositionProportionEChart from './PositionProportionEChart';
import LoadingLayer from '@/components/Spinner/LoadingLayer';
import { LOADING_TYPE } from '@/constants/app';
import { openMarketPositionProportion } from '@/actions/app'
class PositionProportion extends React.Component {
    constructor(props) {
        super(props);
        props.innerRef(this);
        this.state = {
            positionProportion: [{ id: 1, title: 'market_position_proportion_title', isActive: false }],
            holdingsList: [
                {title:'market_position_proportion_stocks_fund', color:'#d77e52', proportion:'100%'},
                // {title:'market_position_proportion_futures', color:'#44c791', proportion:'0%'},
                // {title:'market_position_proportion_Options', color:'#d54e52', proportion:'0%'},
            ],
            marketValueDataList:null,
            isLoading:true
        }
    }

    componentDidMount(){
        const {portfolios} = this.props;
        if(portfolios){
            this.getData()
        }
    }

    componentDidUpdate(preProps){
        if (this.props.portfolios !== preProps.portfolios) {
            if(this.props.portfolios){
                this.getData()
            }
        }
        if (this.props.language && preProps.language !== this.props.language) {
            if(this.props.portfolios){
                this.getData()
            }
        }
    }

    shouldComponentUpdate(nextProps) {
        if (this.props.portfolios && JSON.stringify(this.props.portfolios) !== JSON.stringify(nextProps.portfolios)) {
            return false
        }
        return true
    }

    getData = () => {
        const {portfolios,language} = this.props;
        this.setState({
            isLoading:true
        },() => {
            if(portfolios.portfoliosList){
                let marketValueDataList = [];
                const portfoliosList = portfolios.portfoliosList;
                portfoliosList.map(item => {
                    let marketValueData = {};
                    if(language.lang === "en_US"){
                        marketValueData.name = item.stockShortName;
                    } else {
                        marketValueData.name = item.stockChineseShortName;
                    }
                    marketValueData.value = item.marketValueClientBase;
                    if(item.marketValueClientBase === '0'){
                        marketValueData.label = {
                            normal: {
                                show: false
                            }
                        }
                        return
                    }
                    marketValueDataList.push(marketValueData);
                })
                this.setState({
                    marketValueDataList: marketValueDataList,
                    isLoading:false
                },() => {
                    if(marketValueDataList && this.PositionProportionEChartRef){
                        this.PositionProportionEChartRef.setEChartPieData({
                            series: [{
                                data: marketValueDataList
                            }]
                        })
                    }
                })
            }
        })
    }

    render() { 
        const {positionProportion, holdingsList ,isLoading, marketValueDataList} = this.state;
        const {language} = this.props;
        return ( 
            <div className='market-position-proportion section'>
                <TabHeader tabs={positionProportion} customStyle={CUSTOM_STYLES.HEADER_NORMAL}/>
                {isLoading ?  <LoadingLayer load={isLoading} type={LOADING_TYPE.BIG_IMG} /> : <div className='market-position-proportion-contant'>
                    <div className='market-position-proportion-contant-ECharts' onClick={ isLoading ? ()=>{} :  () => openMarketPositionProportion()} >
                        <PositionProportionEChart
                            innerRef={e => this.PositionProportionEChartRef = e} 
                            data = {marketValueDataList}/>
                    </div>
                    <div className='market-position-proportion-contant-holdings'>
                        <div className='holdings-title'>
                            <div>{getSafe(() => language.market_position_proportion_holdings)}</div>
                            <div>{getSafe(() => language.market_position_proportion_proportion)}</div>
                        </div>
                        {holdingsList.map(item => 
                            <div className='holdings-data' key={item.title}>
                                <div>
                                    <div style={{background:item.color,width:'10px',height:'10px',marginRight:'10px'}}></div>
                                    <div>{getSafe(() => language[item.title])}</div>
                                </div>
                                <div>{item.proportion}</div>
                            </div>
                        )}
                    </div>
                </div>}
            </div>
        );
    }
}
 
export default connect(
    state => ({
        language: state.app.language,
        portfolios: state.trade.portfolios
    }),
    dispatch => ({
        getPortfolioAction: (p, c) => dispatch(getPortfolioAction(p, c))
    })
)(PositionProportion);